import { formatToSpanishTimeZone } from "../utils/formatDate";
import { addDecimalsToNumber } from "../utils/formatNumber";
import { GetEnvironment } from "./ApiCalls/environment/getEnvironment";
import { postCancelSubEnvironment } from "./ApiCalls/environment/postCancelSubEnvironment";
import i18n from 'i18next';

const authInfoString = localStorage.getItem('authInfo');
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const environment = authInfo.environment;
const idUser = authInfo.idUser;

export async function GetEnvironmentService() {
    try {
        const EnvironmentResponse = await GetEnvironment(environment);

        const EnvironmentData = {
            createdAt: formatToSpanishTimeZone(EnvironmentResponse.createdAt),
            expireDate: formatToSpanishTimeZone(EnvironmentResponse.expireDate),
            employeesNumber: EnvironmentResponse.employeesNumber, //esto hay que cambiarlo
            demo: EnvironmentResponse.demo === true ? `${i18n.t("services:services.yes")}` : `${i18n.t("services:services.no")}`,
            enabledSubscription: EnvironmentResponse.subscription,
            amount: `${addDecimalsToNumber(EnvironmentResponse.amount)}€`,
            paymentPlan: EnvironmentResponse.paymentPlan,
            paymentMethod: EnvironmentResponse.paymentMethod,
        }

        return EnvironmentData;

    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}

export async function postCancelSubEnvironmentService() {
    const response = await postCancelSubEnvironment(idUser);

    return response;
}